/**
 * Depends on:
 *
 *   - this.menu
 *   - this.menu.beverage_deposits
 */

import Vue from 'vue';

export default {
  computed: {
    /**
     * List of deposits for the v-select or other UI.
     *
     * Based on MenuDeposits linked to current Menu.
     */
    menuBeverageDeposits() {
      if (!this.menu) {
        return [];
      }
      return this.menu.beverage_deposits.map((deposit) => {
        return {
          id: deposit.id,
          value: deposit.value,
          text: Vue.filter('price')(deposit.value) + ' €',
        };
      });
    },
    idToMenuBeverageDeposit() {
      const lookup = {};
      for (const deposit of this.menuBeverageDeposits) {
        lookup[deposit.id] = deposit;
      }
      return lookup;
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/menuBeverageDeposits.js